import React from 'react';
import { createPluginFactory } from '@udecode/plate-common';

export const ELEMENT_PAGE_BREAK = 'page-break';

/**
 * Enables support for images with widths.
 */
export const createPageBreakPlugin = createPluginFactory({
  key: ELEMENT_PAGE_BREAK,
  isElement: true,
  isVoid: true,
  serializeHtml: ({ attributes, children }) => (
    <div
      {...attributes}
      className="slate-page-break"
      style={{
        pageBreakBefore: 'always',
        pageBreakInside: 'avoid',
      }}
      contentEditable={false}
    >
      {children}
    </div>
  ),
});
